import { getTenantIdForDomain, currentEnvironment, reactapp_S3_READURI } from './tenantHelpers';

  export default function generateS3Link(programId: string, resourceName: string): string {
    const trimmedResourceName = resourceName.trim();
    const formattedResourceName = trimmedResourceName.replace(/ /g, '+');
    return `${reactapp_S3_READURI}/${currentEnvironment}/${getTenantIdForDomain()}/programs/${programId}/${formattedResourceName}`;
  }
